"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createTheme = _interopRequireDefault(require("../utils/createTheme"));

var tefx = (0, _createTheme["default"])({
  colours: {
    primary: ["rgba(14, 71, 162, 1)", "rgba(14, 71, 162, 0.6)", "rgba(14, 71, 162, 0.38)", "rgba(14, 71, 162, 0.16)", "rgba(14, 71, 162, 0.12)", "rgba(14, 71, 162, 0.08)"],
    secondary: ["rgba(255, 255, 0, 1)", "rgba(255, 255, 0, 0.6)", "rgba(255, 255, 0, 0.38)", "rgba(255, 255, 0, 0.16)", "rgba(255, 255, 0, 0.12)", "rgba(255, 255, 0, 0.08)"],
    accent: ["rgba(68, 138, 255, 1)", "rgba(68, 138, 255, 0.6)", "rgba(68, 138, 255, 0.38)", "rgba(68, 138, 255, 0.16)", "rgba(68, 138, 255, 0.12)", "rgba(68, 138, 255, 0.08)"],
    error: ["rgba(191, 70, 48, 1)", "rgba(191, 70, 48, 0.6)", "rgba(191, 70, 48, 0.38)", "rgba(191, 70, 48, 0.16)", "rgba(191, 70, 48, 0.12)"],
    dark: ["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.6)", "rgba(0, 0, 0, 0.38)", "rgba(0, 0, 0, 0.16)", "rgba(0, 0, 0, 0.12)", "rgba(0, 0, 0, 0.08)", "rgba(0, 0, 0, 0.04)"],
    grey: ["rgba(66, 66, 66, 1)", "rgba(66, 66, 66, 0.87)", "rgba(66, 66, 66, 0.6)", "rgba(66, 66, 66, 0.38)", "rgba(66, 66, 66, 0.12)", "rgba(66, 66, 66, 0.08)"],
    light: ["rgba(255, 255, 255, 1)", "rgba(255, 255, 255, 0.6)", "rgba(255, 255, 255, 0.38)", "rgba(255, 255, 255, 0.32)", "rgba(255, 255, 255, 0.24)", "rgba(255, 255, 255, 0.16)", "rgba(255, 255, 255, 0.12)", "rgba(255, 255, 255, 0.08)"]
  },
  spacing: [0, 4, 8, 16, 24, 32, 64],
  heights: [0, 24, 32, 36, 40, 52, 56],
  fontSizes: [0, 10, 12, 14, 16, 20, 24, 32, 48, 60, 96]
});
var _default = tefx;
exports["default"] = _default;